"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SizeSemantics = exports.Sizes = void 0;

var _designLanguage = require("@doordash/design-language");

var _SizeSemantics;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Sizes = {
  Small: _designLanguage.Inset.Sizes.XxSmall,
  Medium: _designLanguage.Inset.Sizes.Small,
  Large: _designLanguage.Inset.Sizes.Large
};
exports.Sizes = Sizes;
var SizeSemantics = (_SizeSemantics = {}, _defineProperty(_SizeSemantics, Sizes.Small, 'FieldSmall'), _defineProperty(_SizeSemantics, Sizes.Medium, 'FieldMedium'), _defineProperty(_SizeSemantics, Sizes.Large, 'FieldLarge'), _SizeSemantics);
exports.SizeSemantics = SizeSemantics;